import { peek, selector } from 'lib/selectors'
import { EnvType, StateInterface } from 'types/state'

const env = (state: StateInterface) => state.env
export const userSelector = selector(env, peek('user'))
export const userToken = selector(env, (e: EnvType) => e.get('tokens'))
export const isAuthorizedSelector = selector(env, peek('isAuthorized'))
export const isLoadingSelector = selector(env, peek('isLoading'))
export const avatarProgressSelector = selector(env, peek('avatarProgress'))
export const profileSummarySelector = selector(env, peek('summary'))
export const otpLoginSelector = selector(env, peek('otpLogin'))
